// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import ApiServices from '../services/ApiServices';
// import { ShowDangerToast, ShowSuccessToast } from '../services/toast';
// import axios from 'axios';
// import mapboxgl from 'mapbox-gl';
// import MapboxDraw from '@mapbox/mapbox-gl-draw';
// import 'mapbox-gl/dist/mapbox-gl.css';
// import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

// // Custom draw mode to disable double-click finishing
// const CustomPolygonMode = { ...MapboxDraw.modes.draw_polygon };
// CustomPolygonMode.onDoubleClick = function (state, e) {
//   console.log('Double-click ignored in custom polygon mode');
// };

// const GeoLocation = ({ storeId, store }) => {
//   // Validate store data
//   const defaultLat = 40.7128; // Default to New York if invalid
//   const defaultLng = -74.0060;
//   const initialGeofence = {
//     address: store.address || '',
//     radius: store.radius || '',
//     latitude: (typeof store.latitude === 'number' && store.latitude >= -90 && store.latitude <= 90) ? store.latitude : defaultLat,
//     longitude: (typeof store.longitude === 'number' && store.longitude >= -180 && store.longitude <= 180) ? store.longitude : defaultLng,
//     polygon: Array.isArray(store.polygon) ? store.polygon : [],
//     travelTime: store.travelTime || '',
//   };

//   const [geofenceType, setGeofenceType] = useState(store.geofenceType || '');
//   const [geofence, setGeofence] = useState(initialGeofence);
//   const [addressSuggestions, setAddressSuggestions] = useState([]);
//   const autocompleteTimeoutRef = useRef(null);
//   const [isAutocompleteLoading, setIsAutocompleteLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const mapContainerRef = useRef(null);
//   const mapRef = useRef(null);
//   const drawRef = useRef(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [isDrawing, setIsDrawing] = useState(false);
//   const tempPointsRef = useRef([]);
//   const drawFeatureIdRef = useRef(null);
//   const isMapLoadedRef = useRef(false);
//   const buttonsRef = useRef(null);

//   // Mapbox access token
//   mapboxgl.accessToken = 'pk.eyJ1IjoiZG9ub3JkaXNwYXRjaCIsImEiOiJjbWMwdjZrZWIwNnU2MmxwdHBsaGkzcm9rIn0.u70VsaQCG6q1r8SLZ8nVLg';

//   useEffect(() => {
//     if (!mapContainerRef.current) return;

//     if (mapRef.current) return;

//     try {
//       mapRef.current = new mapboxgl.Map({
//         container: mapContainerRef.current,
//         style: 'mapbox://styles/mapbox/streets-v12',
//         center: [geofence.longitude, geofence.latitude],
//         zoom: 13,
//         doubleClickZoom: false,
//         dragPan: true,
//         scrollZoom: true,
//       });

//       mapRef.current.addControl(new mapboxgl.NavigationControl(), 'top-right');

//       drawRef.current = new MapboxDraw({
//         displayControlsDefault: false,
//         controls: {
//           polygon: false,
//           trash: false,
//         },
//         modes: {
//           ...MapboxDraw.modes,
//           draw_polygon: CustomPolygonMode,
//         },
//       });
//       mapRef.current.addControl(drawRef.current);

//       mapRef.current.on('load', () => {
//         isMapLoadedRef.current = true;
//         updateMap();
//       });

//       mapRef.current.on('draw.create', handleDrawCreate);
//       mapRef.current.on('draw.update', handleDrawUpdate);
//       mapRef.current.on('draw.delete', handleDrawDelete);
//       mapRef.current.on('click', () => {
//         console.log('Map clicked, isDrawing:', isDrawing, 'mode:', drawRef.current.getMode());
//       });

//       mapRef.current.on('error', (e) => {
//         console.error('Mapbox error:', e);
//         ShowDangerToast('Failed to load map');
//       });
//     } catch (error) {
//       console.error('Map initialization error:', error);
//       ShowDangerToast('Failed to initialize map');
//     }

//     return () => {
//       if (mapRef.current) {
//         try {
//           mapRef.current.remove();
//         } catch (error) {
//           console.warn('Error during map cleanup:', error);
//         }
//         mapRef.current = null;
//         isMapLoadedRef.current = false;
//       }
//     };
//   }, [geofence.latitude, geofence.longitude]);

//   useEffect(() => {
//     if (mapRef.current && isMapLoadedRef.current && geofence.latitude && geofence.longitude) {
//       updateMap();
//     }
//   }, [geofence.latitude, geofence.longitude, geofence.radius, geofence.polygon, geofence.travelTime, geofenceType]);

//   const updateMap = useCallback(() => {
//     if (!mapRef.current || !isMapLoadedRef.current) return;

//     const lat = parseFloat(geofence.latitude);
//     const lng = parseFloat(geofence.longitude);

//     if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
//       console.error('Invalid coordinates:', { lat, lng });
//       ShowDangerToast('Invalid coordinates provided');
//       return;
//     }

//     try {
//       const layers = ['geofence-circle-inner', 'geofence-circle-outer', 'geofence-polygon', 'geofence-polygon-outline', 'store-marker'];
//       const sources = ['geofence-circle', 'geofence-polygon', 'store-marker'];

//       layers.forEach(layer => {
//         if (mapRef.current.getLayer(layer)) {
//           mapRef.current.removeLayer(layer);
//         }
//       });
//       sources.forEach(source => {
//         if (mapRef.current.getSource(source)) {
//           mapRef.current.removeSource(source);
//         }
//       });

//       mapRef.current.setCenter([lng, lat]);

//       mapRef.current.addSource('store-marker', {
//         type: 'geojson',
//         data: {
//           type: 'Feature',
//           geometry: {
//             type: 'Point',
//             coordinates: [lng, lat],
//           },
//           properties: {
//             title: 'Store Location',
//             description: geofence.address || 'No address provided',
//           },
//         },
//       });

//       mapRef.current.addLayer({
//         id: 'store-marker',
//         type: 'circle',
//         source: 'store-marker',
//         paint: {
//           'circle-radius': 8,
//           'circle-color': '#FF0000',
//           'circle-stroke-color': '#FFFFFF',
//           'circle-stroke-width': 2,
//         },
//       });

//       mapRef.current.off('click', 'store-marker');
//       mapRef.current.on('click', 'store-marker', (e) => {
//         new mapboxgl.Popup()
//           .setLngLat(e.features[0].geometry.coordinates)
//           .setHTML(`<b>${e.features[0].properties.title}</b><br>${e.features[0].properties.description}`)
//           .addTo(mapRef.current);
//       });

//       if (geofenceType === 'circle' && geofence.radius) {
//         const radius = parseFloat(geofence.radius);
//         if (isNaN(radius) || radius <= 0) {
//           console.error('Invalid radius:', radius);
//           ShowDangerToast('Invalid radius provided');
//           return;
//         }

//         const radiusInMeters = radius * 1609.34;
//         const innerRadius = Math.min(radiusInMeters * 0.2, 500);

//         mapRef.current.addSource('geofence-circle', {
//           type: 'geojson',
//           data: {
//             type: 'Feature',
//             geometry: {
//               type: 'Point',
//               coordinates: [lng, lat],
//             },
//           },
//         });

//         mapRef.current.addLayer({
//           id: 'geofence-circle-inner',
//           type: 'circle',
//           source: 'geofence-circle',
//           paint: {
//             'circle-radius': {
//               stops: [[10, innerRadius / 1000], [15, innerRadius / 500]],
//               base: 2,
//             },
//             'circle-color': '#87CEEB',
//             'circle-opacity': 0.3,
//           },
//         });

//         mapRef.current.addLayer({
//           id: 'geofence-circle-outer',
//           type: 'circle',
//           source: 'geofence-circle',
//           paint: {
//             'circle-radius': {
//               stops: [[10, radiusInMeters / 1000], [15, radiusInMeters / 500]],
//               base: 2,
//             },
//             'circle-color': '#0000FF',
//             'circle-opacity': 0.2,
//             'circle-stroke-color': '#0000FF',
//             'circle-stroke-width': 3,
//           },
//         });

//         const bounds = new mapboxgl.LngLatBounds(
//           [lng - radius / 69, lat - radius / 69],
//           [lng + radius / 69, lat + radius / 69]
//         );
//         mapRef.current.fitBounds(bounds, { padding: 20 });
//       } else if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length > 0) {
//         const isValidPolygon = geofence.polygon.every(coord =>
//           Array.isArray(coord) &&
//           coord.length === 2 &&
//           typeof coord[0] === 'number' &&
//           typeof coord[1] === 'number' &&
//           coord[1] >= -90 && coord[1] <= 90 &&
//           coord[0] >= -180 && coord[0] <= 180
//         );

//         if (!isValidPolygon) {
//           console.error('Invalid polygon coordinates:', geofence.polygon);
//           ShowDangerToast('Invalid polygon coordinates');
//           return;
//         }

//         mapRef.current.addSource('geofence-polygon', {
//           type: 'geojson',
//           data: {
//             type: 'Feature',
//             geometry: {
//               type: 'Polygon',
//               coordinates: [geofence.polygon.map(coord => [coord[1], coord[0]])], // Mapbox expects [lng, lat]
//             },
//           },
//         });

//         mapRef.current.addLayer({
//           id: 'geofence-polygon',
//           type: 'fill',
//           source: 'geofence-polygon',
//           paint: {
//             'fill-color': '#0000FF',
//             'fill-opacity': 0.2,
//           },
//         });

//         mapRef.current.addLayer({
//           id: 'geofence-polygon-outline',
//           type: 'line',
//           source: 'geofence-polygon',
//           paint: {
//             'line-color': '#0000FF',
//             'line-width': 3,
//             'line-opacity': 0.8,
//           },
//         });

//         if (geofence.polygon.length >= 1) {
//           const bounds = geofence.polygon.reduce(
//             (b, coord) => b.extend([coord[1], coord[0]]),
//             new mapboxgl.LngLatBounds([geofence.polygon[0][1], geofence.polygon[0][0]], [geofence.polygon[0][1], geofence.polygon[0][0]])
//           );
//           mapRef.current.fitBounds(bounds, { padding: 20 });
//         }
//       }
//     } catch (error) {
//       console.error('Error updating map:', error);
//       ShowDangerToast('Failed to update map');
//     }
//   }, [geofence, geofenceType]);

//   // const startDrawing = useCallback(() => {
//   //   if (!mapRef.current || !isMapLoadedRef.current || isDrawing) {
//   //     ShowDangerToast('Map is not ready or drawing is already active');
//   //     return;
//   //   }
//   //   setIsDrawing(true);
//   //   setIsEditing(true);
//   //   tempPointsRef.current = [];
//   //   drawFeatureIdRef.current = null;
//   //   drawRef.current.deleteAll();
//   //   drawRef.current.changeMode('draw_polygon');
//   //   mapRef.current.getCanvas().style.cursor = 'crosshair';
//   //   mapRef.current.dragPan.disable();
//   //   mapRef.current.scrollZoom.disable();
//   //   mapRef.current.getCanvas().style.pointerEvents = 'auto';
//   //   console.log('Start drawing, mode:', drawRef.current.getMode());
//   //   ShowSuccessToast('Click on the map to start drawing a polygon');
//   // }, [isDrawing]);

//   const startDrawing = useCallback(() => {
//   if (!mapRef.current || !isMapLoadedRef.current || isDrawing) {
//     ShowDangerToast('Map is not ready or drawing is already active');
//     return;
//   }
//   setIsDrawing(true);
//   setIsEditing(true);
//   tempPointsRef.current = [];
//   drawFeatureIdRef.current = null;
//   drawRef.current.deleteAll(); // Clear existing draw features
//   if (mapRef.current.getLayer('geofence-polygon')) mapRef.current.removeLayer('geofence-polygon');
//   if (mapRef.current.getLayer('geofence-polygon-outline')) mapRef.current.removeLayer('geofence-polygon-outline');
//   if (mapRef.current.getSource('geofence-polygon')) mapRef.current.removeSource('geofence-polygon');
//   drawRef.current.changeMode('draw_polygon');
//   mapRef.current.getCanvas().style.cursor = 'crosshair';
//   mapRef.current.dragPan.disable();
//   mapRef.current.scrollZoom.disable();
//   mapRef.current.getCanvas().style.pointerEvents = 'auto';
//   ShowSuccessToast('Click on the map to start drawing a polygon');
// }, [isDrawing]);

//   // const handleDrawCreate = useCallback((e) => {
//   //   console.log('Draw create fired, mode:', drawRef.current?.getMode());
//   //   if (drawRef.current?.getMode() !== 'draw_polygon') {
//   //     console.log('Draw create skipped: not in polygon draw mode');
//   //     return;
//   //   }
//   //   const coordinates = e.features[0].geometry.coordinates[0];
//   //   tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]); // Convert to [lat, lng]
//   //   drawFeatureIdRef.current = e.features[0].id;
//   //   console.log('Draw create:', tempPointsRef.current, 'Feature ID:', drawFeatureIdRef.current);
//   // }, []);

//   // const handleDrawUpdate = useCallback((e) => {
//   //   console.log('Draw update fired, mode:', drawRef.current?.getMode());
//   //   if (drawRef.current?.getMode() !== 'draw_polygon') {
//   //     console.log('Draw update skipped: not in polygon draw mode');
//   //     return;
//   //   }
//   //   const coordinates = e.features[0].geometry.coordinates[0];
//   //   tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]); // Convert to [lat, lng]
//   //   drawFeatureIdRef.current = e.features[0].id;
//   //   console.log('Draw update:', tempPointsRef.current);
//   // }, []);

//   const handleDrawCreate = useCallback((e) => {
//   if (drawRef.current?.getMode() !== 'draw_polygon') return;
//   const coordinates = e.features[0].geometry.coordinates[0];
//   tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
//   if (tempPointsRef.current.length >= 3 && tempPointsRef.current[0][0] !== tempPointsRef.current[tempPointsRef.current.length - 1][0]) {
//     tempPointsRef.current.push([...tempPointsRef.current[0]]); // Close the polygon
//   }
//   drawFeatureIdRef.current = e.features[0].id;
//   updateMap(); // Update map to reflect changes
// }, []);

// const handleDrawUpdate = useCallback((e) => {
//   if (drawRef.current?.getMode() !== 'draw_polygon') return;
//   const coordinates = e.features[0].geometry.coordinates[0];
//   tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
//   if (tempPointsRef.current.length >= 3 && tempPointsRef.current[0][0] !== tempPointsRef.current[tempPointsRef.current.length - 1][0]) {
//     tempPointsRef.current.push([...tempPointsRef.current[0]]); // Close the polygon
//   }
//   drawFeatureIdRef.current = e.features[0].id;
//   updateMap(); // Update map to reflect changes
// }, []);

//   const handleDrawDelete = useCallback(() => {
//     tempPointsRef.current = [];
//     setGeofence({ ...geofence, polygon: [] });
//     drawFeatureIdRef.current = null;
//     console.log('Draw delete');
//     updateMap();
//   }, [geofence]);

//   // const undoLastPoint = useCallback(() => {
//   //   console.log('Clicked undo, points:', tempPointsRef.current.length, 'Feature ID:', drawFeatureIdRef.current);
//   //   if (tempPointsRef.current.length <= 0) {
//   //     ShowDangerToast('No points to undo');
//   //     return;
//   //   }
//   //   if (!drawFeatureIdRef.current) {
//   //     ShowDangerToast('No drawing feature found');
//   //     return;
//   //   }
//   //   tempPointsRef.current.pop();
//   //   if (tempPointsRef.current.length >= 2) {
//   //     const updatedPolygon = [...tempPointsRef.current, tempPointsRef.current[0]]; // Close the polygon
//   //     drawRef.current.set({
//   //       type: 'FeatureCollection',
//   //       features: [
//   //         {
//   //           type: 'Feature',
//   //           id: drawFeatureIdRef.current,
//   //           geometry: {
//   //             type: 'Polygon',
//   //             coordinates: [updatedPolygon.map(coord => [coord[1], coord[0]])], // Convert back to [lng, lat]
//   //           },
//   //         },
//   //       ],
//   //     });
//   //     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//   //     ShowSuccessToast('Last point undone');
//   //   } else {
//   //     drawRef.current.deleteAll();
//   //     setGeofence(prev => ({ ...prev, polygon: [] }));
//   //     drawFeatureIdRef.current = null;
//   //     tempPointsRef.current = [];
//   //     ShowSuccessToast('Drawing cleared');
//   //   }
//   // }, []);

//   const undoLastPoint = useCallback(() => {
//   if (tempPointsRef.current.length <= 0) {
//     ShowDangerToast('No points to undo');
//     return;
//   }
//   if (!drawFeatureIdRef.current) {
//     ShowDangerToast('No drawing feature found');
//     return;
//   }
//   tempPointsRef.current.pop();
//   if (tempPointsRef.current.length >= 1) {
//     const updatedPolygon = [...tempPointsRef.current, tempPointsRef.current[0]]; // Close the polygon
//     drawRef.current.set({
//       type: 'FeatureCollection',
//       features: [
//         {
//           type: 'Feature',
//           id: drawFeatureIdRef.current,
//           geometry: {
//             type: 'Polygon',
//             coordinates: [updatedPolygon.map(coord => [coord[1], coord[0]])],
//           },
//         },
//       ],
//     });
//     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//     drawRef.current.changeMode('draw_polygon'); // Keep draw mode active
//     ShowSuccessToast('Last point undone');
//   } else {
//     drawRef.current.deleteAll();
//     setGeofence(prev => ({ ...prev, polygon: [] }));
//     drawFeatureIdRef.current = null;
//     tempPointsRef.current = [];
//     drawRef.current.changeMode('draw_polygon'); // Restart drawing
//     ShowSuccessToast('Drawing cleared');
//   }
//   updateMap();
// }, [geofence]);

//     const handleGeofenceSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     if (!geofence.address) {
//       ShowDangerToast('Address is required');
//       return;
//     }
//     if (!geofenceType) {
//       ShowDangerToast('Please select a geofence type');
//       return;
//     }
//     if (geofenceType === 'circle' && !geofence.radius) {
//       ShowDangerToast('Radius is required for circle geofence');
//       return;
//     }
//     if ((geofenceType === 'polygon' || geofenceType === 'travel-time') && geofence.polygon.length < 3) {
//       ShowDangerToast('Polygon geofence requires at least 3 points');
//       return;
//     }
//     if (geofenceType === 'travel-time' && !geofence.travelTime) {
//       ShowDangerToast('Travel time is required for travel-time geofence');
//       return;
//     }
//     setIsSubmitting(true);
//     try {
//       await ApiServices.putData('/stores/geofence', {
//         storeId,
//         latitude: geofence.latitude,
//         longitude: geofence.longitude,
//         radius: geofenceType === 'circle' ? parseFloat(geofence.radius) || 20 : null,
//         address: geofence.address,
//         geofenceType,
//         polygon: geofenceType === 'polygon' || geofenceType === 'travel-time' ? geofence.polygon : [],
//         travelTime: geofenceType === 'travel-time' ? parseInt(geofence.travelTime) : null,
//       });
//       ShowSuccessToast('Geofence updated successfully');
//       setIsEditing(false);
//       setIsDrawing(false);
//       drawRef.current.changeMode('simple_select');
//       mapRef.current.getCanvas().style.cursor = '';
//       mapRef.current.dragPan.enable();
//       mapRef.current.scrollZoom.enable();
//       mapRef.current.getCanvas().style.pointerEvents = 'auto';
//     } catch (error) {
//       console.error('Geofence submit error:', error);
//       ShowDangerToast('Failed to update geofence');
//     } finally {
//       setIsSubmitting(false);
//     }
//   }, [geofence, geofenceType, storeId]);

//   const finishDrawing = useCallback(async () => {
//     console.log('Clicked on done, points:', tempPointsRef.current.length);
//     if (tempPointsRef.current.length < 3) {
//       ShowDangerToast('A polygon requires at least 3 points');
//       return;
//     }
//     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//     setIsDrawing(false);
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     mapRef.current.getCanvas().style.pointerEvents = 'auto';
//     // try {
//     //   await handleGeofenceSubmit({ preventDefault: () => {} });
//     //   ShowSuccessToast('Polygon saved');
//     // } catch (error) {
//     //   console.error('Error saving polygon:', error);
//     //   ShowDangerToast('Failed to save polygon');
//     // }
//     ShowSuccessToast('Polygon drawing finished. Save to confirm.');
//   }, [handleGeofenceSubmit]);

//   const cancelDrawing = useCallback(() => {
//     setIsDrawing(false);
//     setGeofence({ ...geofence, polygon: [] });
//     drawRef.current.deleteAll();
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     mapRef.current.getCanvas().style.pointerEvents = 'auto';
//     drawFeatureIdRef.current = null;
//     console.log('Cancel drawing');
//     updateMap();
//   }, [geofence]);



//   const handleAddressChange = useCallback(async (e) => {
//     const query = e.target.value;
//     setGeofence({ ...geofence, address: query });

//     if (autocompleteTimeoutRef.current) {
//       clearTimeout(autocompleteTimeoutRef.current);
//     }

//     if (query.length < 3) {
//       setAddressSuggestions([]);
//       return;
//     }

//     autocompleteTimeoutRef.current = setTimeout(async () => {
//       setIsAutocompleteLoading(true);
//       try {
//         const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`, {
//           params: {
//             access_token: mapboxgl.accessToken,
//             country: 'us',
//             limit: 5,
//             autocomplete: true,
//             types: 'address,poi',
//           },
//         });

//         setAddressSuggestions(response.data.features.map(feature => ({
//           formattedAddress: feature.place_name,
//           latitude: feature.geometry.coordinates[1],
//           longitude: feature.geometry.coordinates[0],
//           id: feature.id,
//         })) || []);
//       } catch (error) {
//         console.error('Autocomplete error:', error);
//         ShowDangerToast('Failed to load address suggestions');
//       } finally {
//         setIsAutocompleteLoading(false);
//       }
//     }, 300);
//   }, [geofence]);

//   const handleAddressSelect = useCallback((selectedAddress) => {
//     const newLat = parseFloat(selectedAddress.latitude);
//     const newLng = parseFloat(selectedAddress.longitude);

//     if (isNaN(newLat) || isNaN(newLng) || newLat < -90 || newLat > 90 || newLng < -180 || newLng > 180) {
//       console.error('Invalid address coordinates:', { latitude: newLat, longitude: newLng });
//       ShowDangerToast('Invalid address coordinates selected');
//       return;
//     }

//     setGeofence({
//       ...geofence,
//       address: selectedAddress.formattedAddress,
//       latitude: newLat,
//       longitude: newLng,
//       radius: '',
//       polygon: [],
//       travelTime: '',
//     });
//     setGeofenceType('');
//     setIsEditing(false);
//     setIsDrawing(false);
//     drawRef.current.deleteAll();
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     mapRef.current.getCanvas().style.pointerEvents = 'auto';
//     setAddressSuggestions([]);
//   }, [geofence]);

//   const handleTravelTimeGeofence = useCallback(async () => {
//     if (!geofence.latitude || !geofence.longitude || !geofence.travelTime) {
//       ShowDangerToast('Please provide address and travel time');
//       return;
//     }
//     setIsSubmitting(true);
//     try {
//       const response = await axios.get(`https://api.mapbox.com/isochrone/v1/mapbox/driving/${geofence.longitude},${geofence.latitude}`, {
//         params: {
//           contours_minutes: parseInt(geofence.travelTime),
//           polygons: true,
//           access_token: mapboxgl.accessToken,
//         },
//       });
//       const coordinates = response.data.features[0].geometry.coordinates[0].map(coord => [coord[1], coord[0]]); // Convert to [lat, lng]
//       setGeofence({ ...geofence, polygon: coordinates });
//       setIsEditing(true);
//       updateMap();
//     } catch (error) {
//       console.error('Isochrone error:', error);
//       ShowDangerToast('Failed to create travel-time geofence');
//     } finally {
//       setIsSubmitting(false);
//     }
//   }, [geofence, updateMap]);

//   const isSaveButtonEnabled = useCallback(() => {
//     if (!geofence.address || !geofenceType) return false;
//     if (geofenceType === 'circle' && !geofence.radius) return false;
//     if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length < 3) return false;
//     if (geofenceType === 'travel-time' && !geofence.travelTime) return false;
//     return true;
//   }, [geofence, geofenceType]);

//   return (
//     <div className="bg-[#111C44] p-6 rounded-xl shadow w-full max-w-5xl">
//       <h2 className="text-xl font-semibold mb-4 text-white">Manage Geofence</h2>
//       <form onSubmit={handleGeofenceSubmit} className="space-y-4">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 relative">
//           <div>
//             <label className="block mb-1 text-sm font-medium text-white">Address</label>
//             <input
//               type="text"
//               value={geofence.address}
//               onChange={handleAddressChange}
//               className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//               required
//             />
//             {addressSuggestions.length > 0 && (
//               <ul className="absolute z-[1000] bg-[#1F2A5A] border border-gray-600 rounded mt-1 w-full max-h-60 overflow-auto">
//                 {isAutocompleteLoading && (
//                   <li className="px-3 py-2 text-sm text-gray-400 italic">Loading suggestions...</li>
//                 )}
//                 {addressSuggestions.map((address, index) => (
//                   <li
//                     key={index}
//                     className="px-3 py-2 hover:bg-[#2A3575] cursor-pointer text-sm text-white"
//                     onClick={() => handleAddressSelect(address)}
//                   >
//                     {address.formattedAddress}
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//           <div>
//             <label className="block mb-1 text-sm font-medium text-white">Geofence Type</label>
//             <select
//               value={geofenceType}
//               onChange={(e) => {
//                 const newType = e.target.value;
//                 setGeofenceType(newType);
//                 setIsEditing(true);
//                 setGeofence({ ...geofence, radius: '', polygon: [], travelTime: '' });
//                 drawRef.current.deleteAll();
//                 drawRef.current.changeMode('simple_select');
//                 mapRef.current.getCanvas().style.cursor = '';
//                 mapRef.current.dragPan.enable();
//                 mapRef.current.scrollZoom.enable();
//                 mapRef.current.getCanvas().style.pointerEvents = 'auto';
//                 setIsDrawing(false);
//                 updateMap();
//               }}
//               className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//             >
//               <option value="">Select Geofence Type</option>
//               <option value="circle">Circle</option>
//               <option value="polygon">Polygon</option>
//               <option value="travel-time">Travel Time</option>
//             </select>
//           </div>
//           {geofenceType === 'circle' && (
//             <div>
//               <label className="block mb-1 text-sm font-medium text-white">Radius (mi)</label>
//               <input
//                 type="number"
//                 value={geofence.radius}
//                 onChange={(e) => {
//                   setGeofence({ ...geofence, radius: e.target.value });
//                   setIsEditing(true);
//                 }}
//                 className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//                 required
//               />
//             </div>
//           )}
//           {geofenceType === 'travel-time' && (
//             <div>
//               <label className="block mb-1 text-sm font-medium text-white">Travel Time (minutes)</label>
//               <input
//                 type="number"
//                 value={geofence.travelTime}
//                 onChange={(e) => {
//                   setGeofence({ ...geofence, travelTime: e.target.value });
//                   setIsEditing(true);
//                 }}
//                 className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//                 required
//               />
//             </div>
//           )}
//         </div>
//         <div className="flex gap-2 relative z-[1000] pointer-events-auto" ref={buttonsRef}>
//           {!isEditing && (
//             <button
//               type="button"
//               onClick={() => {
//                 console.log('Clicked Edit Geofence');
//                 setIsEditing(true);
//                 if (geofenceType === 'polygon') {
//                   startDrawing();
//                 }
//               }}
//               className="bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//             >
//               Edit Geofence
//             </button>
//           )}
//           {isEditing && (
//             <>
//               <button
//                 type="submit"
//                 className="bg-green-600 hover:bg-green-700 px-4 py-1.5 rounded text-sm text-white flex items-center gap-2 disabled:opacity-60 pointer-events-auto"
//                 disabled={isSubmitting || !isSaveButtonEnabled()}
//               >
//                 {isSubmitting && (
//                   <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8"
//                     ></path>
//                   </svg>
//                 )}
//                 {isSubmitting ? 'Saving...' : 'Save Geofence'}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   console.log('Clicked Cancel');
//                   setGeofenceType(store.geofenceType || '');
//                   setGeofence({
//                     address: store.address || '',
//                     radius: store.radius || '',
//                     latitude: (typeof store.latitude === 'number' && store.latitude >= -90 && store.latitude <= 90) ? store.latitude : defaultLat,
//                     longitude: (typeof store.longitude === 'number' && store.longitude >= -180 && store.longitude <= 180) ? store.longitude : defaultLng,
//                     polygon: Array.isArray(store.polygon) ? store.polygon : [],
//                     travelTime: store.travelTime || '',
//                   });
//                   setIsEditing(false);
//                   setIsDrawing(false);
//                   drawRef.current.deleteAll();
//                   drawRef.current.changeMode('simple_select');
//                   mapRef.current.getCanvas().style.cursor = '';
//                   mapRef.current.dragPan.enable();
//                   mapRef.current.scrollZoom.enable();
//                   mapRef.current.getCanvas().style.pointerEvents = 'auto';
//                   updateMap();
//                 }}
//                 className="bg-red-600 hover:bg-red-700 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//               >
//                 Cancel
//               </button>
//             </>
//           )}
//           {geofenceType === 'polygon' && isEditing && !isDrawing && (
//             <button
//               type="button"
//               onClick={() => {
//                 console.log('Clicked Draw Polygon');
//                 startDrawing();
//               }}
//               className="bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//             >
//               Draw Polygon
//             </button>
//           )}
//           {geofenceType === 'travel-time' && isEditing && (
//             <button
//               type="button"
//               onClick={() => {
//                 console.log('Clicked Generate Travel Time Geofence');
//                 handleTravelTimeGeofence();
//               }}
//               className="bg-blue-600 hover:bg-blue-700 px-5 py-1.5 rounded text-sm text-white pointer-events-auto"
//               disabled={isSubmitting}
//             >
//               Generate Travel Time
//             </button>
//           )}
//           {isDrawing && (
//             <>
//               <button
//                 type="button"
//                 onClick={() => {
//                   console.log('Attempting to click Undo');
//                   undoLastPoint();
//                 }}
//                 className="bg-yellow-600 hover:bg-yellow-400 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//               >
//                 Undo
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   console.log('Attempting to click Done');
//                   finishDrawing();
//                 }}
//                 className="bg-green-600 hover:bg-green-700 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//               >
//                 Done
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   console.log('Clicked Cancel Drawing');
//                   cancelDrawing();
//                 }}
//                 className="bg-red-600 hover:bg-red-700 px-4 py-1.5 rounded text-sm text-white pointer-events-auto"
//               >
//                 Cancel Drawing
//               </button>
//             </>
//           )}
//         </div>
//       </form>

//       <div className="mt-4 relative z-0">
//         <div
//           ref={mapContainerRef}
//           style={{ width: '100%', height: '320px' }}
//           className="rounded-lg overflow-hidden border border-gray-600"
//         />
//       </div>
//     </div>
//   );
// };

// export default GeoLocation;

// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import ApiServices from '../services/ApiServices';
// import mapboxgl from 'mapbox-gl';
// import MapboxDraw from '@mapbox/mapbox-gl-draw';
// import axios from 'axios';
// import 'mapbox-gl/dist/mapbox-gl.css';
// import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

// // Mock toast functions (replace with your actual implementation)
// const ShowDangerToast = (message) => console.error(message);
// const ShowSuccessToast = (message) => console.log(message);

// const GeoLocation = ({ storeId, store }) => {
//   // Validate store data
//   const defaultLat = 40.7128; // Default to New York if invalid
//   const defaultLng = -74.0060;
//   const initialGeofence = {
//     address: store.address || '',
//     radius: store.radius || '',
//     latitude: (typeof store.latitude === 'number' && store.latitude >= -90 && store.latitude <= 90) ? store.latitude : defaultLat,
//     longitude: (typeof store.longitude === 'number' && store.longitude >= -180 && store.longitude <= 180) ? store.longitude : defaultLng,
//     polygon: Array.isArray(store.polygon) ? store.polygon : [],
//     travelTime: store.travelTime || '',
//   };

//   const [geofenceType, setGeofenceType] = useState(store.geofenceType || '');
//   const [geofence, setGeofence] = useState(initialGeofence);
//   const [addressSuggestions, setAddressSuggestions] = useState([]);
//   const autocompleteTimeoutRef = useRef(null);
//   const [isAutocompleteLoading, setIsAutocompleteLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const mapContainerRef = useRef(null);
//   const mapRef = useRef(null);
//   const drawRef = useRef(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [isDrawing, setIsDrawing] = useState(false);
//   const tempPointsRef = useRef([]);
//   const drawFeatureIdRef = useRef(null);
//   const isMapLoadedRef = useRef(false);

//   mapboxgl.accessToken = 'pk.eyJ1IjoiZG9ub3JkaXNwYXRjaCIsImEiOiJjbWMwdjZrZWIwNnU2MmxwdHBsaGkzcm9rIn0.u70VsaQCG6q1r8SLZ8nVLg';

//   useEffect(() => {
//     if (!mapContainerRef.current) return;

//     if (mapRef.current) return;

//     mapRef.current = new mapboxgl.Map({
//       container: mapContainerRef.current,
//       style: 'mapbox://styles/mapbox/streets-v12',
//       center: [geofence.longitude, geofence.latitude],
//       zoom: 13,
//       doubleClickZoom: false,
//       dragPan: true,
//       scrollZoom: true,
//     });

//     mapRef.current.addControl(new mapboxgl.NavigationControl(), 'top-right');

//     drawRef.current = new MapboxDraw({
//       displayControlsDefault: false,
//       controls: { polygon: false, trash: false },
//     });
//     mapRef.current.addControl(drawRef.current);

//     mapRef.current.on('load', () => {
//       isMapLoadedRef.current = true;
//       updateMap();
//     });

//     mapRef.current.on('draw.create', handleDrawCreate);
//     mapRef.current.on('draw.update', handleDrawUpdate);
//     mapRef.current.on('draw.delete', handleDrawDelete);

//     return () => {
//       if (mapRef.current) {
//         mapRef.current.remove();
//         mapRef.current = null;
//         isMapLoadedRef.current = false;
//       }
//     };
//   }, [geofence.latitude, geofence.longitude]);

//   useEffect(() => {
//     if (mapRef.current && isMapLoadedRef.current) {
//       updateMap();
//     }
//   }, [geofence.latitude, geofence.longitude, geofence.radius, geofence.polygon, geofence.travelTime, geofenceType]);

//   const updateMap = useCallback(() => {
//     if (!mapRef.current || !isMapLoadedRef.current) return;

//     const lat = parseFloat(geofence.latitude);
//     const lng = parseFloat(geofence.longitude);

//     if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
//       ShowDangerToast('Invalid coordinates');
//       return;
//     }

//     mapRef.current.setCenter([lng, lat]);

//     // Remove existing layers and sources
//     const layers = ['store-marker', 'geofence-circle-inner', 'geofence-circle-outer', 'geofence-polygon', 'geofence-polygon-outline'];
//     const sources = ['store-marker', 'geofence-circle', 'geofence-polygon'];
//     layers.forEach(layer => { if (mapRef.current.getLayer(layer)) mapRef.current.removeLayer(layer); });
//     sources.forEach(source => { if (mapRef.current.getSource(source)) mapRef.current.removeSource(source); });

//     // Add store marker
//     mapRef.current.addSource('store-marker', {
//       type: 'geojson',
//       data: { type: 'Feature', geometry: { type: 'Point', coordinates: [lng, lat] } },
//     });
//     mapRef.current.addLayer({
//       id: 'store-marker',
//       type: 'circle',
//       source: 'store-marker',
//       paint: { 'circle-radius': 8, 'circle-color': '#FF0000' },
//     });

//     // Add circle geofence if applicable
//     if (geofenceType === 'circle' && geofence.radius) {
//       const radius = parseFloat(geofence.radius);
//       if (!isNaN(radius) && radius > 0) {
//         const radiusInMeters = radius * 1609.34;
//         mapRef.current.addSource('geofence-circle', {
//           type: 'geojson',
//           data: { type: 'Feature', geometry: { type: 'Point', coordinates: [lng, lat] } },
//         });
//         mapRef.current.addLayer({
//           id: 'geofence-circle-inner',
//           type: 'circle',
//           source: 'geofence-circle',
//           paint: { 'circle-radius': radiusInMeters * 0.2 / 1000, 'circle-color': '#87CEEB', 'circle-opacity': 0.3 },
//         });
//         mapRef.current.addLayer({
//           id: 'geofence-circle-outer',
//           type: 'circle',
//           source: 'geofence-circle',
//           paint: { 'circle-radius': radiusInMeters / 1000, 'circle-color': '#0000FF', 'circle-opacity': 0.2, 'circle-stroke-color': '#0000FF', 'circle-stroke-width': 3 },
//         });
//       }
//     }

//     // Add polygon geofence if applicable
//     if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length > 0) {
//       const isValidPolygon = geofence.polygon.every(coord => Array.isArray(coord) && coord.length === 2 && typeof coord[0] === 'number' && typeof coord[1] === 'number');
//       if (isValidPolygon) {
//         mapRef.current.addSource('geofence-polygon', {
//           type: 'geojson',
//           data: { type: 'Feature', geometry: { type: 'Polygon', coordinates: [geofence.polygon.map(coord => [coord[1], coord[0]])] } },
//         });
//         mapRef.current.addLayer({
//           id: 'geofence-polygon',
//           type: 'fill',
//           source: 'geofence-polygon',
//           paint: { 'fill-color': '#0000FF', 'fill-opacity': 0.2 },
//         });
//         mapRef.current.addLayer({
//           id: 'geofence-polygon-outline',
//           type: 'line',
//           source: 'geofence-polygon',
//           paint: { 'line-color': '#0000FF', 'line-width': 3, 'line-opacity': 0.8 },
//         });
//       }
//     }
//   }, [geofence, geofenceType]);

//   const startDrawing = useCallback(() => {
//     if (!mapRef.current || !isMapLoadedRef.current || isDrawing) {
//       ShowDangerToast('Map is not ready or drawing is already active');
//       return;
//     }
//     setIsDrawing(true);
//     setIsEditing(true);
//     tempPointsRef.current = [];
//     drawFeatureIdRef.current = null;
//     drawRef.current.deleteAll();
//     if (mapRef.current.getLayer('geofence-polygon')) mapRef.current.removeLayer('geofence-polygon');
//     if (mapRef.current.getLayer('geofence-polygon-outline')) mapRef.current.removeLayer('geofence-polygon-outline');
//     if (mapRef.current.getSource('geofence-polygon')) mapRef.current.removeSource('geofence-polygon');
//     drawRef.current.changeMode('draw_polygon');
//     mapRef.current.getCanvas().style.cursor = 'crosshair';
//     mapRef.current.dragPan.disable();
//     mapRef.current.scrollZoom.disable();
//     ShowSuccessToast('Click on the map to start drawing a polygon');
//   }, [isDrawing]);

//   const handleDrawCreate = useCallback((e) => {
//     if (drawRef.current.getMode() !== 'draw_polygon') return;
//     const coordinates = e.features[0].geometry.coordinates[0];
//     tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
//     drawFeatureIdRef.current = e.features[0].id;
//     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//     updateMap();
//   }, []);

//   const handleDrawUpdate = useCallback((e) => {
//     if (drawRef.current.getMode() !== 'draw_polygon') return;
//     const coordinates = e.features[0].geometry.coordinates[0];
//     tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
//     drawFeatureIdRef.current = e.features[0].id;
//     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//     updateMap();
//   }, []);

//   const handleDrawDelete = useCallback(() => {
//     tempPointsRef.current = [];
//     setGeofence({ ...geofence, polygon: [] });
//     drawFeatureIdRef.current = null;
//     updateMap();
//   }, [geofence]);

//   // Keyboard shortcut 'u' to undo last point while drawing
//   useEffect(() => {
//     const handleKeyPress = (e) => {
//       if (isDrawing && e.key === 'u' && tempPointsRef.current.length > 0 && drawRef.current.getMode() === 'draw_polygon') {
//         tempPointsRef.current.pop();
//         if (tempPointsRef.current.length >= 1) {
//           const updatedPolygon = [...tempPointsRef.current];
//           drawRef.current.set({
//             type: 'FeatureCollection',
//             features: [{
//               type: 'Feature',
//               id: drawFeatureIdRef.current,
//               geometry: { type: 'Polygon', coordinates: [updatedPolygon.map(coord => [coord[1], coord[0]])] },
//             }],
//           });
//           setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//           updateMap();
//         } else {
//           drawRef.current.deleteAll();
//           setGeofence(prev => ({ ...prev, polygon: [] }));
//           drawFeatureIdRef.current = null;
//           tempPointsRef.current = [];
//           updateMap();
//         }
//       }
//     };
//     window.addEventListener('keydown', handleKeyPress);
//     return () => window.removeEventListener('keydown', handleKeyPress);
//   }, [isDrawing, geofence]);

//   const handleGeofenceSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     if (!geofence.address) {
//       ShowDangerToast('Address is required');
//       return;
//     }
//     if (!geofenceType) {
//       ShowDangerToast('Please select a geofence type');
//       return;
//     }
//     if (geofenceType === 'circle' && !geofence.radius) {
//       ShowDangerToast('Radius is required for circle geofence');
//       return;
//     }
//     if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length < 3) {
//       ShowDangerToast('Polygon geofence requires at least 3 points');
//       return;
//     }
//     if (geofenceType === 'travel-time' && !geofence.travelTime) {
//       ShowDangerToast('Travel time is required for travel-time geofence');
//       return;
//     }
//     setIsSubmitting(true);
//     try {
//       await ApiServices.putData('/stores/geofence', {
//         storeId,
//         latitude: geofence.latitude,
//         longitude: geofence.longitude,
//         radius: geofenceType === 'circle' ? parseFloat(geofence.radius) : null,
//         address: geofence.address,
//         geofenceType,
//         polygon: ['polygon', 'travel-time'].includes(geofenceType) ? geofence.polygon : [],
//         travelTime: geofenceType === 'travel-time' ? parseInt(geofence.travelTime) : null,
//       });
//       ShowSuccessToast('Geofence updated successfully');
//       setIsEditing(false);
//       setIsDrawing(false);
//       drawRef.current.changeMode('simple_select');
//       mapRef.current.getCanvas().style.cursor = '';
//       mapRef.current.dragPan.enable();
//       mapRef.current.scrollZoom.enable();
//     } catch (error) {
//       ShowDangerToast('Failed to update geofence');
//     } finally {
//       setIsSubmitting(false);
//     }
//   }, [geofence, geofenceType, storeId]);

//   const finishDrawing = useCallback(() => {
//     if (tempPointsRef.current.length < 3) {
//       ShowDangerToast('A polygon requires at least 3 points');
//       return;
//     }
//     setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
//     setIsDrawing(false);
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     ShowSuccessToast('Polygon drawing finished. Save to confirm.');
//   }, []);

//   const cancelDrawing = useCallback(() => {
//     setIsDrawing(false);
//     setGeofence({ ...geofence, polygon: [] });
//     drawRef.current.deleteAll();
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     drawFeatureIdRef.current = null;
//     updateMap();
//   }, [geofence]);

//   const handleAddressChange = useCallback(async (e) => {
//     const query = e.target.value;
//     setGeofence({ ...geofence, address: query });

//     if (autocompleteTimeoutRef.current) clearTimeout(autocompleteTimeoutRef.current);

//     if (query.length < 3) {
//       setAddressSuggestions([]);
//       return;
//     }

//     setIsAutocompleteLoading(true);
//     try {
//       const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`, {
//         params: { access_token: mapboxgl.accessToken, country: 'us', limit: 5, autocomplete: true, types: 'address,poi' },
//       });
//       setAddressSuggestions(response.data.features.map(feature => ({
//         formattedAddress: feature.place_name,
//         latitude: feature.geometry.coordinates[1],
//         longitude: feature.geometry.coordinates[0],
//         id: feature.id,
//       })) || []);
//     } catch (error) {
//       ShowDangerToast('Failed to load address suggestions');
//     } finally {
//       setIsAutocompleteLoading(false);
//     }
//   }, [geofence]);

//   const handleAddressSelect = useCallback((selectedAddress) => {
//     const newLat = parseFloat(selectedAddress.latitude);
//     const newLng = parseFloat(selectedAddress.longitude);
//     if (isNaN(newLat) || isNaN(newLng) || newLat < -90 || newLat > 90 || newLng < -180 || newLng > 180) {
//       ShowDangerToast('Invalid address coordinates');
//       return;
//     }
//     setGeofence({
//       ...geofence,
//       address: selectedAddress.formattedAddress,
//       latitude: newLat,
//       longitude: newLng,
//       radius: '',
//       polygon: [],
//       travelTime: '',
//     });
//     setGeofenceType('');
//     setIsEditing(false);
//     setIsDrawing(false);
//     drawRef.current.deleteAll();
//     drawRef.current.changeMode('simple_select');
//     mapRef.current.getCanvas().style.cursor = '';
//     mapRef.current.dragPan.enable();
//     mapRef.current.scrollZoom.enable();
//     setAddressSuggestions([]);
//     updateMap();
//   }, [geofence]);

//   const handleTravelTimeGeofence = useCallback(async () => {
//     if (!geofence.latitude || !geofence.longitude || !geofence.travelTime) {
//       ShowDangerToast('Please provide address and travel time');
//       return;
//     }
//     setIsSubmitting(true);
//     try {
//       const response = await axios.get(`https://api.mapbox.com/isochrone/v1/mapbox/driving/${geofence.longitude},${geofence.latitude}`, {
//         params: { contours_minutes: parseInt(geofence.travelTime), polygons: true, access_token: mapboxgl.accessToken },
//       });
//       const coordinates = response.data.features[0].geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
//       setGeofence({ ...geofence, polygon: coordinates });
//       setIsEditing(true);
//       updateMap();
//     } catch (error) {
//       ShowDangerToast('Failed to create travel-time geofence');
//     } finally {
//       setIsSubmitting(false);
//     }
//   }, [geofence]);

//   const isSaveButtonEnabled = useCallback(() => {
//     if (!geofence.address || !geofenceType) return false;
//     if (geofenceType === 'circle' && !geofence.radius) return false;
//     if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length < 3) return false;
//     if (geofenceType === 'travel-time' && !geofence.travelTime) return false;
//     return true;
//   }, [geofence, geofenceType]);

//   return (
//     <div className="bg-[#111C44] p-6 rounded-xl shadow w-full max-w-5xl">
//       <h2 className="text-xl font-semibold mb-4 text-white">Manage Geofence</h2>
//       <form onSubmit={handleGeofenceSubmit} className="space-y-4">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 relative">
//           <div>
//             <label className="block mb-1 text-sm font-medium text-white">Address</label>
//             <input
//               type="text"
//               value={geofence.address}
//               onChange={handleAddressChange}
//               className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//               required
//             />
//             {addressSuggestions.length > 0 && (
//               <ul className="absolute z-[1000] bg-[#1F2A5A] border border-gray-600 rounded mt-1 w-full max-h-60 overflow-auto">
//                 {isAutocompleteLoading && <li className="px-3 py-2 text-sm text-gray-400 italic">Loading suggestions...</li>}
//                 {addressSuggestions.map((address, index) => (
//                   <li
//                     key={index}
//                     className="px-3 py-2 hover:bg-[#2A3575] cursor-pointer text-sm text-white"
//                     onClick={() => handleAddressSelect(address)}
//                   >
//                     {address.formattedAddress}
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//           <div>
//             <label className="block mb-1 text-sm font-medium text-white">Geofence Type</label>
//             <select
//               value={geofenceType}
//               onChange={(e) => {
//                 const newType = e.target.value;
//                 setGeofenceType(newType);
//                 setIsEditing(true);
//                 setGeofence({ ...geofence, radius: '', polygon: [], travelTime: '' });
//                 drawRef.current.deleteAll();
//                 drawRef.current.changeMode('simple_select');
//                 mapRef.current.getCanvas().style.cursor = '';
//                 mapRef.current.dragPan.enable();
//                 mapRef.current.scrollZoom.enable();
//                 setIsDrawing(false);
//                 updateMap();
//               }}
//               className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//             >
//               <option value="">Select Geofence Type</option>
//               <option value="circle">Circle</option>
//               <option value="polygon">Polygon</option>
//               <option value="travel-time">Travel Time</option>
//             </select>
//           </div>
//           {geofenceType === 'circle' && (
//             <div>
//               <label className="block mb-1 text-sm font-medium text-white">Radius (mi)</label>
//               <input
//                 type="number"
//                 value={geofence.radius}
//                 onChange={(e) => setGeofence({ ...geofence, radius: e.target.value })}
//                 className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//                 required
//               />
//             </div>
//           )}
//           {geofenceType === 'travel-time' && (
//             <div>
//               <label className="block mb-1 text-sm font-medium text-white">Travel Time (minutes)</label>
//               <input
//                 type="number"
//                 value={geofence.travelTime}
//                 onChange={(e) => setGeofence({ ...geofence, travelTime: e.target.value })}
//                 className="w-full px-3 py-2 rounded bg-[#1F2A5A] text-white border border-gray-600 text-sm"
//                 required
//               />
//             </div>
//           )}
//         </div>
//         <div className="flex gap-2 relative z-[1000]">
//           {!isEditing && (
//             <button
//               type="button"
//               onClick={() => setIsEditing(true)}
//               className="bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded text-sm text-white"
//             >
//               Edit Geofence
//             </button>
//           )}
//           {isEditing && (
//             <>
//               <button
//                 type="submit"
//                 className="bg-green-600 hover:bg-green-700 px-4 py-1.5 rounded text-sm text-white disabled:opacity-60"
//                 disabled={isSubmitting || !isSaveButtonEnabled()}
//               >
//                 {isSubmitting ? 'Saving...' : 'Save Geofence'}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setGeofenceType(store.geofenceType || '');
//                   setGeofence(initialGeofence);
//                   setIsEditing(false);
//                   setIsDrawing(false);
//                   drawRef.current.deleteAll();
//                   drawRef.current.changeMode('simple_select');
//                   mapRef.current.getCanvas().style.cursor = '';
//                   mapRef.current.dragPan.enable();
//                   mapRef.current.scrollZoom.enable();
//                   updateMap();
//                 }}
//                 className="bg-red-600 hover:bg-red-700 px-4 py-1.5 rounded text-sm text-white"
//               >
//                 Cancel
//               </button>
//             </>
//           )}
//           {geofenceType === 'polygon' && isEditing && !isDrawing && (
//             <button
//               type="button"
//               onClick={startDrawing}
//               className="bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded text-sm text-white"
//             >
//               Draw Polygon
//             </button>
//           )}
//           {geofenceType === 'travel-time' && isEditing && (
//             <button
//               type="button"
//               onClick={handleTravelTimeGeofence}
//               className="bg-blue-600 hover:bg-blue-700 px-5 py-1.5 rounded text-sm text-white"
//               disabled={isSubmitting}
//             >
//               Generate Travel Time
//             </button>
//           )}
//           {isDrawing && (
//             <>
//               <button
//                 type="button"
//                 onClick={finishDrawing}
//                 className="bg-green-600 hover:bg-green-700 px-4 py-1.5 rounded text-sm text-white"
//               >
//                 Done
//               </button>
//               <button
//                 type="button"
//                 onClick={cancelDrawing}
//                 className="bg-red-600 hover:bg-red-700 px-4 py-1.5 rounded text-sm text-white"
//               >
//                 Cancel Drawing
//               </button>
//             </>
//           )}
//         </div>
//       </form>
//       <div className="mt-4 relative z-0">
//         <div
//           ref={mapContainerRef}
//           style={{ width: '100%', height: '320px' }}
//           className="rounded-lg overflow-hidden border border-gray-600"
//         />
//       </div>
//     </div>
//   );
// };
// import { useState,useRef,useEffect,useCallback, } from 'react';

// export default GeoLocation;import React, { useState, useEffect, useRef, useCallback } from 'react';

import React, { useState, useEffect, useRef, useCallback } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import ApiServices from '../services/ApiServices';
import axios from 'axios';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { ShowDangerToast, ShowSuccessToast } from '../services/toast';
import colors from '../styles/colors';


const GeoLocation =({ storeId, profile, profileImage, storeName ,store }) => {
  const defaultLat = 40.7128;
  const defaultLng = -74.0060;
  const initialGeofence = {
    address: store.address || '',
    radius: store.radius || '',
    latitude: (typeof store.latitude === 'number' && store.latitude >= -90 && store.latitude <= 90) ? store.latitude : defaultLat,
    longitude: (typeof store.longitude === 'number' && store.longitude >= -180 && store.longitude <= 180) ? store.longitude : defaultLng,
    polygon: Array.isArray(store.polygon) ? store.polygon : [],
    travelTime: store.travelTime || '',
  };

  const [geofenceType, setGeofenceType] = useState(store.geofenceType || '');
  const [geofence, setGeofence] = useState(initialGeofence);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const autocompleteTimeoutRef = useRef(null);
  const [isAutocompleteLoading, setIsAutocompleteLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const drawRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const tempPointsRef = useRef([]);
  const drawFeatureIdRef = useRef(null);
  const isMapLoadedRef = useRef(false);
  
  const previousGeofenceTypeRef = useRef(store.geofenceType || '');
  const previousGeofenceRef = useRef(initialGeofence);

  mapboxgl.accessToken = 'pk.eyJ1IjoiZG9ub3JkaXNwYXRjaCIsImEiOiJjbWMwdjZrZWIwNnU2MmxwdHBsaGkzcm9rIn0.u70VsaQCG6q1r8SLZ8nVLg';

  function createGeoJSONCircle(center, radiusInMeters, points = 64) {
    const [longitude, latitude] = center;
    const coords = {
      latitude: latitude,
      longitude: longitude
    };
    const km = radiusInMeters / 1000;
    const ret = [];
    const distanceX = km / (111.320 * Math.cos((coords.latitude * Math.PI) / 180));
    const distanceY = km / 110.574;

    for (let i = 0; i < points; i++) {
      const theta = (i / points) * (2 * Math.PI);
      const x = distanceX * Math.cos(theta);
      const y = distanceY * Math.sin(theta);
      ret.push([coords.longitude + x, coords.latitude + y]);
    }
    ret.push(ret[0]);
    return {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [ret],
      },
    };
  }

 
  const clearGeofenceLayers = useCallback(() => {
    if (!mapRef.current || !isMapLoadedRef.current) return;
    
    const layers = [
      'geofence-circle-fill', 
      'geofence-circle-outline', 
      'geofence-polygon', 
      'geofence-polygon-outline'
    ];
    const sources = ['geofence-circle', 'geofence-polygon'];
    
    layers.forEach(layer => {
      if (mapRef.current.getLayer(layer)) {
        mapRef.current.removeLayer(layer);
      }
    });
    
    sources.forEach(source => {
      if (mapRef.current.getSource(source)) {
        mapRef.current.removeSource(source);
      }
    });
  }, []);

  useEffect(() => {
    if (!mapContainerRef.current) return;
    if (mapRef.current) return;
    
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [geofence.longitude, geofence.latitude],
      zoom: 13,
      doubleClickZoom: false,
      dragPan: true,
      scrollZoom: true,
    });
    
    mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');
    
    drawRef.current = new MapboxDraw({
      displayControlsDefault: false,
      controls: { polygon: false, trash: false },
    });
    mapRef.current.addControl(drawRef.current);

    mapRef.current.on('load', () => {
      isMapLoadedRef.current = true;
      previousGeofenceTypeRef.current = store.geofenceType || '';
      previousGeofenceRef.current = { ...initialGeofence };
      updateMap();
    });

    mapRef.current.on('draw.create', handleDrawCreate);
    mapRef.current.on('draw.update', handleDrawUpdate);
    mapRef.current.on('draw.delete', handleDrawDelete);

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
        isMapLoadedRef.current = false;
      }
    };
  }, [geofence.latitude, geofence.longitude]);

  useEffect(() => {
    if (mapRef.current && isMapLoadedRef.current) {
      updateMap();
    }
  }, [geofence.latitude, geofence.longitude, geofence.radius, geofence.polygon, geofence.travelTime, geofenceType]);

  const updateMap = useCallback(() => {
    if (!mapRef.current || !isMapLoadedRef.current) return;
    
    const lat = parseFloat(geofence.latitude);
    const lng = parseFloat(geofence.longitude);

    if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
      ShowDangerToast('Invalid coordinates');
      return;
    }

 
    clearGeofenceLayers();
    
    if (mapRef.current.getLayer('store-marker')) {
      mapRef.current.removeLayer('store-marker');
    }
    if (mapRef.current.getSource('store-marker')) {
      mapRef.current.removeSource('store-marker');
    }
    
    mapRef.current.addSource('store-marker', {
      type: 'geojson',
      data: { 
        type: 'Feature', 
        geometry: { 
          type: 'Point', 
          coordinates: [lng, lat] 
        } 
      },
    });
    
    mapRef.current.addLayer({
      id: 'store-marker',
      type: 'circle',
      source: 'store-marker',
      paint: { 
        'circle-radius': 10, 
        'circle-color': '#3B82F6',
        'circle-stroke-width': 3,
        'circle-stroke-color': '#ffffff',
      },
    });

    mapRef.current.setCenter([lng, lat]);

    if (geofenceType === 'circle' && geofence.radius) {
      const radiusMiles = parseFloat(geofence.radius);
      if (!isNaN(radiusMiles) && radiusMiles > 0) {
        const radiusMeters = radiusMiles * 1609.34;
        const circleFeature = createGeoJSONCircle([lng, lat], radiusMeters, 64);

        mapRef.current.addSource('geofence-circle', {
          type: 'geojson',
          data: circleFeature,
        });

        mapRef.current.addLayer({
          id: 'geofence-circle-fill',
          type: 'fill',
          source: 'geofence-circle',
          paint: {
            'fill-color': '#3B82F6',
            'fill-opacity': 0.1,
          },
        });

        mapRef.current.addLayer({
          id: 'geofence-circle-outline',
          type: 'line',
          source: 'geofence-circle',
          paint: {
            'line-color': '#3B82F6',
            'line-width': 2,
            'line-opacity': 0.7,
            'line-dasharray': [4, 3],
          },
        });
      }
    } else if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length > 0) {
      const isValidPolygon = geofence.polygon.every(coord => 
        Array.isArray(coord) && 
        coord.length === 2 && 
        typeof coord[0] === 'number' && 
        typeof coord[1] === 'number'
      );
      
      if (isValidPolygon) {
        mapRef.current.addSource('geofence-polygon', {
          type: 'geojson',
          data: { 
            type: 'Feature', 
            geometry: { 
              type: 'Polygon', 
              coordinates: [geofence.polygon.map(coord => [coord[1], coord[0]])] 
            } 
          },
        });
        
        mapRef.current.addLayer({
          id: 'geofence-polygon',
          type: 'fill',
          source: 'geofence-polygon',
          paint: { 
            'fill-color': '#3B82F6', 
            'fill-opacity': 0.1 
          },
        });
        
        mapRef.current.addLayer({
          id: 'geofence-polygon-outline',
          type: 'line',
          source: 'geofence-polygon',
          paint: { 
            'line-color': '#3B82F6', 
            'line-width': 2, 
            'line-opacity': 0.7,
            'line-dasharray': [4, 3],
          },
        });
      }
    }
  }, [geofence, geofenceType, clearGeofenceLayers]);

  const startDrawing = useCallback(() => {
    if (!mapRef.current || !isMapLoadedRef.current || isDrawing) {
      ShowDangerToast('Map is not ready or drawing is already active');
      return;
    }
    setIsDrawing(true);
    tempPointsRef.current = [];
    drawFeatureIdRef.current = null;
    drawRef.current.deleteAll();
    
    clearGeofenceLayers();
    
    drawRef.current.changeMode('draw_polygon');
    mapRef.current.getCanvas().style.cursor = 'crosshair';
    mapRef.current.dragPan.disable();
    mapRef.current.scrollZoom.disable();
    ShowSuccessToast('Click on the map to start drawing a polygon');
  }, [isDrawing, clearGeofenceLayers]);

  const handleDrawCreate = useCallback((e) => {
    if (drawRef.current.getMode() !== 'draw_polygon') return;
    const coordinates = e.features[0].geometry.coordinates[0];
    tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
    drawFeatureIdRef.current = e.features[0].id;
    setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
  
    if (geofenceType === 'polygon' || geofenceType === 'travel-time') {
      updateMap();
    }
  }, [geofenceType, updateMap]);

  const handleDrawUpdate = useCallback((e) => {
    if (drawRef.current.getMode() !== 'draw_polygon') return;
    const coordinates = e.features[0].geometry.coordinates[0];
    tempPointsRef.current = coordinates.slice(0, -1).map(coord => [coord[1], coord[0]]);
    drawFeatureIdRef.current = e.features[0].id;
    setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
   
    if (geofenceType === 'polygon' || geofenceType === 'travel-time') {
      updateMap();
    }
  }, [geofenceType, updateMap]);

  const handleDrawDelete = useCallback(() => {
    tempPointsRef.current = [];
    setGeofence(prev => ({ ...prev, polygon: [] }));
    drawFeatureIdRef.current = null;
    updateMap();
  }, [updateMap]);

  const handleUndo = useCallback(() => {
    if (!isDrawing || tempPointsRef.current.length <= 0 || !drawFeatureIdRef.current) return;
    tempPointsRef.current.pop();
    if (tempPointsRef.current.length >= 1) {
      const updatedPolygon = [...tempPointsRef.current];
      drawRef.current.setFeatureProperty(drawFeatureIdRef.current, 'coordinates', [updatedPolygon.map(coord => [coord[1], coord[0]])]);
      setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
      updateMap();
      ShowSuccessToast('Last point undone');
    } else {
      drawRef.current.deleteAll();
      setGeofence(prev => ({ ...prev, polygon: [] }));
      drawFeatureIdRef.current = null;
      tempPointsRef.current = [];
      updateMap();
      ShowSuccessToast('Drawing cleared');
    }
  }, [isDrawing, updateMap]);

  const handleGeofenceSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!geofence.address) { 
      ShowDangerToast('Address is required'); 
      return; 
    }
    if (!geofenceType) { 
      ShowDangerToast('Please select a geofence type'); 
      return; 
    }
    if (geofenceType === 'circle' && !geofence.radius) { 
      ShowDangerToast('Radius is required for circle geofence'); 
      return; 
    }
    if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length < 3) { 
      ShowDangerToast('Polygon geofence requires at least 3 points'); 
      return; 
    }
    if (geofenceType === 'travel-time' && !geofence.travelTime) { 
      ShowDangerToast('Travel time is required for travel-time geofence'); 
      return; 
    }

    setIsSubmitting(true);
    try {
      await ApiServices.putData('/stores/geofence', {
        storeId,
        latitude: geofence.latitude,
        longitude: geofence.longitude,
        radius: geofenceType === 'circle' ? parseFloat(geofence.radius) : null,
        address: geofence.address,
        geofenceType,
        polygon: ['polygon', 'travel-time'].includes(geofenceType) ? geofence.polygon : [],
        travelTime: geofenceType === 'travel-time' ? parseInt(geofence.travelTime) : null,
      });
      
      ShowSuccessToast('Geofence updated successfully');
      setIsDrawing(false);
      previousGeofenceTypeRef.current = geofenceType;
      previousGeofenceRef.current = { ...geofence };
      
      drawRef.current.changeMode('simple_select');
      mapRef.current.getCanvas().style.cursor = '';
      mapRef.current.dragPan.enable();
      mapRef.current.scrollZoom.enable();
    } catch {
      ShowDangerToast('Failed to update geofence');
    } finally {
      setIsSubmitting(false);
    }
  }, [geofence, geofenceType, storeId]);

  const finishDrawing = useCallback(() => {
    if (tempPointsRef.current.length < 3) { 
      ShowDangerToast('A polygon requires at least 3 points'); 
      return; 
    }
    setGeofence(prev => ({ ...prev, polygon: [...tempPointsRef.current] }));
    setIsDrawing(false);
    drawRef.current.changeMode('simple_select');
    mapRef.current.getCanvas().style.cursor = '';
    mapRef.current.dragPan.enable();
    mapRef.current.scrollZoom.enable();
    ShowSuccessToast('Polygon drawing finished. Save to confirm.');
  }, []);

  const cancelDrawing = useCallback(() => {
    setIsDrawing(false);
    setGeofence(prev => ({ ...prev, polygon: [] }));
    drawRef.current.deleteAll();
    drawRef.current.changeMode('simple_select');
    mapRef.current.getCanvas().style.cursor = '';
    mapRef.current.dragPan.enable();
    mapRef.current.scrollZoom.enable();
    drawFeatureIdRef.current = null;
    updateMap();
  }, [updateMap]);

  const handleAddressChange = useCallback(async (e) => {
    const query = e.target.value;
    setGeofence(prev => ({ ...prev, address: query }));
    
    if (autocompleteTimeoutRef.current) clearTimeout(autocompleteTimeoutRef.current);
    
    if (query.length < 3) { 
      setAddressSuggestions([]); 
      return; 
    }
    
    setIsAutocompleteLoading(true);
    try {
      const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`, {
        params: { 
          access_token: mapboxgl.accessToken, 
          country: 'us', 
          limit: 5, 
          autocomplete: true, 
          types: 'address,poi' 
        },
      });
      setAddressSuggestions(response.data.features.map(feature => ({
        formattedAddress: feature.place_name,
        latitude: feature.geometry.coordinates[1],
        longitude: feature.geometry.coordinates[0],
        id: feature.id,
      })) || []);
    } catch {
      ShowDangerToast('Failed to load address suggestions');
    } finally {
      setIsAutocompleteLoading(false);
    }
  }, []);

  const handleAddressSelect = useCallback((selectedAddress) => {
    const newLat = parseFloat(selectedAddress.latitude);
    const newLng = parseFloat(selectedAddress.longitude);
    
    if (isNaN(newLat) || isNaN(newLng) || newLat < -90 || newLat > 90 || newLng < -180 || newLng > 180) {
      ShowDangerToast('Invalid address coordinates');
      return;
    }
    
    setGeofence({
      ...geofence,
      address: selectedAddress.formattedAddress,
      latitude: newLat,
      longitude: newLng,
      radius: '',
      polygon: [],
      travelTime: '',
    });
    
    setGeofenceType('');
    setIsDrawing(false);
    drawRef.current.deleteAll();
    drawRef.current.changeMode('simple_select');
    mapRef.current.getCanvas().style.cursor = '';
    mapRef.current.dragPan.enable();
    mapRef.current.scrollZoom.enable();
    setAddressSuggestions([]);
    updateMap();
  }, [geofence, updateMap]);

  const handleTravelTimeGeofence = useCallback(async () => {
    if (!geofence.latitude || !geofence.longitude || !geofence.travelTime) {
      ShowDangerToast('Please provide address and travel time');
      return;
    }
    
    setIsSubmitting(true);
    try {
      const response = await axios.get(`https://api.mapbox.com/isochrone/v1/mapbox/driving/${geofence.longitude},${geofence.latitude}`, {
        params: { 
          contours_minutes: parseInt(geofence.travelTime), 
          polygons: true, 
          access_token: mapboxgl.accessToken 
        },
      });
      
      const coordinates = response.data.features[0].geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
      setGeofence(prev => ({ ...prev, polygon: coordinates }));
      updateMap();
    } catch {
      ShowDangerToast('Failed to create travel-time geofence');
    } finally {
      setIsSubmitting(false);
    }
  }, [geofence, updateMap]);

  const isSaveButtonEnabled = useCallback(() => {
    if (!geofence.address || !geofenceType) return false;
    if (geofenceType === 'circle' && !geofence.radius) return false;
    if (['polygon', 'travel-time'].includes(geofenceType) && geofence.polygon.length < 3) return false;
    if (geofenceType === 'travel-time' && !geofence.travelTime) return false;
    return true;
  }, [geofence, geofenceType]);

  const handleCoverageTypeChange = (type) => {
    setGeofenceType(type);
    setGeofence(prev => ({
      ...prev,
      radius: type === 'circle' ? prev.radius : '',
      polygon: (type === 'polygon' || type === 'travel-time') ? prev.polygon : [],
      travelTime: type === 'travel-time' ? prev.travelTime || '45' : '',
    }));
    if (drawRef.current) {
      drawRef.current.deleteAll();
      drawRef.current.changeMode('simple_select');
    }
    if (mapRef.current) {
      mapRef.current.getCanvas().style.cursor = '';
      mapRef.current.dragPan.enable();
      mapRef.current.scrollZoom.enable();
    }
    setIsDrawing(false);
  };

  const handleReset = () => {
    setGeofenceType(previousGeofenceTypeRef.current);
    setGeofence({ ...previousGeofenceRef.current });
    setIsDrawing(false);
    if (drawRef.current) {
      drawRef.current.deleteAll();
      drawRef.current.changeMode('simple_select');
    }
    if (mapRef.current) {
      mapRef.current.getCanvas().style.cursor = '';
      mapRef.current.dragPan.enable();
      mapRef.current.scrollZoom.enable();
    }
  };

  const handleMapClick = useCallback((e) => {
    if (isDrawing) return;
    const { lng, lat } = e.lngLat;
    setGeofence(prev => ({
      ...prev,
      latitude: parseFloat(lat.toFixed(6)),
      longitude: parseFloat(lng.toFixed(6)),
    }));
  }, [isDrawing]);

  useEffect(() => {
    if (!mapRef.current) return;
    mapRef.current.on('click', handleMapClick);
    return () => {
      if (mapRef.current) {
        mapRef.current.off('click', handleMapClick);
      }
    };
  }, [handleMapClick]);

  const tealColor = '#0D9488';

  return (
    <div className="min-h-0">
      <div className="mb-6">
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1a2332', margin: 0 }}>Coverage Area</h1>
        <p style={{ fontSize: '0.95rem', color: '#6B7280', marginTop: '4px' }}>Define the service area for pickup requests</p>
      </div>

      <div style={{ display: 'flex', gap: '24px', alignItems: 'stretch', minHeight: '560px' }}>
        <div style={{ flex: '0 0 40%', maxWidth: '40%' }}>
          <form onSubmit={handleGeofenceSubmit} style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '28px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '20px' }}>
              <h2 style={{ fontSize: '1.2rem', fontWeight: 600, color: '#1a2332', margin: 0 }}>Settings</h2>
              <p style={{ fontSize: '0.85rem', color: '#9CA3AF', marginTop: '4px' }}>Configure the boundaries for accepting pickup requests</p>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: 600, color: '#1a2332', marginBottom: '12px' }}>Coverage Type</label>

              <div
                onClick={() => handleCoverageTypeChange('circle')}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px',
                  border: `1px solid ${geofenceType === 'circle' ? tealColor : '#E5E7EB'}`,
                  borderRadius: '10px', cursor: 'pointer', marginBottom: '10px',
                  background: geofenceType === 'circle' ? '#F0FDFA' : '#fff',
                  transition: 'all 0.15s ease',
                }}
              >
                <div style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  border: `2px solid ${geofenceType === 'circle' ? tealColor : '#D1D5DB'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  {geofenceType === 'circle' && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: tealColor }} />}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={geofenceType === 'circle' ? tealColor : '#6B7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg>
                  <div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1a2332' }}>Distance Radius</div>
                    <div style={{ fontSize: '0.78rem', color: '#9CA3AF' }}>Simple circle based on miles from center</div>
                  </div>
                </div>
              </div>

              <div
                onClick={() => handleCoverageTypeChange('travel-time')}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px',
                  border: `1px solid ${geofenceType === 'travel-time' ? tealColor : '#E5E7EB'}`,
                  borderRadius: '10px', cursor: 'pointer',
                  background: geofenceType === 'travel-time' ? '#F0FDFA' : '#fff',
                  transition: 'all 0.15s ease',
                }}
              >
                <div style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  border: `2px solid ${geofenceType === 'travel-time' ? tealColor : '#D1D5DB'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  {geofenceType === 'travel-time' && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#1a2332' }} />}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={geofenceType === 'travel-time' ? '#1a2332' : '#6B7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1a2332' }}>Travel Time</div>
                    <div style={{ fontSize: '0.78rem', color: '#9CA3AF' }}>Based on driving time from center</div>
                  </div>
                </div>
              </div>

              <div
                onClick={() => handleCoverageTypeChange('polygon')}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px',
                  border: `1px solid ${geofenceType === 'polygon' ? tealColor : '#E5E7EB'}`,
                  borderRadius: '10px', cursor: 'pointer', marginTop: '10px',
                  background: geofenceType === 'polygon' ? '#F0FDFA' : '#fff',
                  transition: 'all 0.15s ease',
                }}
              >
                <div style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  border: `2px solid ${geofenceType === 'polygon' ? tealColor : '#D1D5DB'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  {geofenceType === 'polygon' && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: tealColor }} />}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={geofenceType === 'polygon' ? tealColor : '#6B7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5"/></svg>
                  <div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1a2332' }}>Custom Polygon</div>
                    <div style={{ fontSize: '0.78rem', color: '#9CA3AF' }}>Draw a custom boundary on the map</div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: 600, color: '#1a2332', marginBottom: '8px' }}>Center Address</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  value={geofence.address}
                  onChange={handleAddressChange}
                  required
                  style={{
                    width: '100%', padding: '10px 44px 10px 14px', border: '1px solid #E5E7EB',
                    borderRadius: '8px', fontSize: '0.9rem', outline: 'none', background: '#fff',
                    boxSizing: 'border-box',
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(
                        (pos) => {
                          setGeofence(prev => ({
                            ...prev,
                            latitude: parseFloat(pos.coords.latitude.toFixed(6)),
                            longitude: parseFloat(pos.coords.longitude.toFixed(6)),
                          }));
                        },
                        (err) => {
                          if (err.code === 1) {
                            ShowDangerToast('Location permission denied');
                          } else {
                            ShowDangerToast('Unable to get current location');
                          }
                        }
                      );
                    } else {
                      ShowDangerToast('Geolocation is not supported by this browser');
                    }
                  }}
                  style={{
                    position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', padding: '6px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6B7280',
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg>
                </button>
              </div>
              {isAutocompleteLoading && <p style={{ marginTop: '6px', fontSize: '0.8rem', color: '#9CA3AF' }}>Loading suggestions...</p>}
              {addressSuggestions.length > 0 && (
                <ul className="list-none p-0 mt-1.5 border border-gray-200 rounded-lg bg-white shadow-lg max-h-[200px] overflow-y-auto z-50 relative">
                  {addressSuggestions.map((sug) => (
                    <li
                      key={sug.id}
                      onClick={() => handleAddressSelect(sug)}
                      className="px-3.5 py-2.5 cursor-pointer text-sm text-gray-700 border-b border-gray-100 last:border-b-0 hover:bg-teal-50 transition-colors"
                    >
                      {sug.formattedAddress}
                    </li>
                  ))}
                </ul>
              )}
              <p style={{ fontSize: '0.78rem', color: tealColor, marginTop: '6px', fontStyle: 'italic' }}>Or click on the map to set the center point</p>
            </div>

            {geofenceType === 'circle' && (
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: 600, color: '#1a2332', marginBottom: '8px' }}>Radius (miles)</label>
                <input
                  type="number"
                  value={geofence.radius}
                  onChange={e => setGeofence(prev => ({ ...prev, radius: e.target.value }))}
                  required
                  min="0"
                  step="0.1"
                  style={{
                    width: '100%', padding: '10px 14px', border: '1px solid #E5E7EB',
                    borderRadius: '8px', fontSize: '0.9rem', outline: 'none', background: '#fff',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
            )}

            {geofenceType === 'travel-time' && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <label style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1a2332' }}>Travel Time</label>
                  <span style={{ fontSize: '0.95rem', fontWeight: 600, color: tealColor }}>{geofence.travelTime || 45} minutes</span>
                </div>
                <input
                  type="range"
                  min="5"
                  max="120"
                  step="5"
                  value={geofence.travelTime || 45}
                  onChange={e => setGeofence(prev => ({ ...prev, travelTime: e.target.value }))}
                  style={{
                    width: '100%', height: '6px', appearance: 'none', WebkitAppearance: 'none',
                    background: `linear-gradient(to right, ${tealColor} 0%, ${tealColor} ${((parseInt(geofence.travelTime || 45) - 5) / 115) * 100}%, #E5E7EB ${((parseInt(geofence.travelTime || 45) - 5) / 115) * 100}%, #E5E7EB 100%)`,
                    borderRadius: '3px', outline: 'none', cursor: 'pointer',
                  }}
                />
                <p style={{ fontSize: '0.78rem', color: '#9CA3AF', marginTop: '8px', fontStyle: 'italic' }}>Travel time boundaries are approximate</p>
              </div>
            )}

            {geofenceType === 'polygon' && (
              <div style={{ marginBottom: '16px' }}>
                {!isDrawing ? (
                  <button
                    type="button"
                    onClick={startDrawing}
                    style={{
                      width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                      padding: '12px 20px', border: `1px solid ${tealColor}`, borderRadius: '8px',
                      background: '#F0FDFA', color: tealColor, fontSize: '0.9rem', fontWeight: 500,
                      cursor: 'pointer', transition: 'all 0.15s ease',
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5"/></svg>
                    Draw Polygon on Map
                  </button>
                ) : (
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button type="button" onClick={handleUndo} disabled={tempPointsRef.current.length <= 0}
                      style={{ flex: 1, padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', background: '#fff', color: '#374151', fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer', opacity: tempPointsRef.current.length <= 0 ? 0.5 : 1 }}>
                      Undo
                    </button>
                    <button type="button" onClick={finishDrawing}
                      style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '8px', background: tealColor, color: '#fff', fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer' }}>
                      Done
                    </button>
                    <button type="button" onClick={cancelDrawing}
                      style={{ flex: 1, padding: '10px', border: '1px solid #EF4444', borderRadius: '8px', background: '#fff', color: '#EF4444', fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer' }}>
                      Cancel
                    </button>
                  </div>
                )}
                {geofence.polygon.length > 0 && !isDrawing && (
                  <p style={{ fontSize: '0.78rem', color: '#9CA3AF', marginTop: '8px' }}>{geofence.polygon.length} points defined</p>
                )}
                {isDrawing && (
                  <p style={{ fontSize: '0.78rem', color: tealColor, marginTop: '8px', fontStyle: 'italic' }}>Click on the map to add polygon points</p>
                )}
              </div>
            )}

            {geofenceType === 'travel-time' && (
              <button
                type="button"
                onClick={handleTravelTimeGeofence}
                disabled={isSubmitting || !geofence.travelTime}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '12px 20px', border: `1px solid ${tealColor}`, borderRadius: '8px',
                  background: '#F0FDFA', color: tealColor, fontSize: '0.9rem', fontWeight: 500,
                  cursor: isSubmitting || !geofence.travelTime ? 'not-allowed' : 'pointer',
                  transition: 'all 0.15s ease', marginBottom: '16px',
                  opacity: isSubmitting || !geofence.travelTime ? 0.5 : 1,
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                Generate Travel Time Boundary
              </button>
            )}

            <div style={{ background: '#F9FAFB', border: '1px solid #F3F4F6', borderRadius: '8px', padding: '14px 16px', marginBottom: '20px' }}>
              <p style={{ fontSize: '0.78rem', color: '#9CA3AF', marginBottom: '6px' }}>Center Coordinates</p>
              <p style={{ fontSize: '0.9rem', color: '#374151', fontFamily: 'monospace', margin: 0 }}>
                {parseFloat(geofence.latitude).toFixed(6)},&nbsp;&nbsp;{parseFloat(geofence.longitude).toFixed(6)}
              </p>
            </div>

            <div style={{ marginTop: 'auto', display: 'flex', gap: '12px', paddingTop: '12px' }}>
              <button
                type="button"
                onClick={handleReset}
                style={{
                  flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '12px 20px', border: '1px solid #D1D5DB', borderRadius: '8px',
                  background: '#fff', color: '#374151', fontSize: '0.9rem', fontWeight: 500,
                  cursor: 'pointer', transition: 'all 0.15s ease',
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                Reset
              </button>
              <button
                type="submit"
                disabled={isSubmitting || !isSaveButtonEnabled()}
                style={{
                  flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  padding: '12px 20px', border: 'none', borderRadius: '8px',
                  background: isSubmitting || !isSaveButtonEnabled() ? '#94A3B8' : tealColor,
                  color: '#fff', fontSize: '0.9rem', fontWeight: 500,
                  cursor: isSubmitting || !isSaveButtonEnabled() ? 'not-allowed' : 'pointer',
                  transition: 'all 0.15s ease', opacity: isSubmitting || !isSaveButtonEnabled() ? 0.7 : 1,
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>

        <div style={{ flex: '1 1 60%', position: 'relative' }}>
          <div
            ref={mapContainerRef}
            style={{ width: '100%', height: '100%', minHeight: '560px', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GeoLocation;